<p-toast />

<p-drawer [(visible)]="drawerOpened" [closeOnEscape]="true" styleClass="flex flex-col">
  <ng-template #header>
    <div class="flex items-center">
      <img [src]="brandService.logoPath" class="p-2 mt-1 w-40" />
    </div>
  </ng-template>

  <div class="flex flex-col h-full">
    <div class="flex-1 overflow-y-auto">
      <ng-container *ngTemplateOutlet="menuTemplate; context: { isMobile: true }"></ng-container>
    </div>

    <!-- Version and Developer Info -->
    <div class="px-4 py-2 flex-shrink-0 text-center">
      <p class="text-xs text-surface-500">
        v{{ appVersion }} • ©
        <a [href]="brandService.mainUrl" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">
          {{ brandService.brandName }}
        </a>
      </p>
    </div>
  </div>
</p-drawer>

<div class="flex h-screen overflow-hidden">
  <div
    id="appSidebar"
    class="h-full hidden lg:block bg-surface-0 flex-shrink-0 border-r border-surface select-none overflow-hidden transition-all duration-300 relative"
    [ngClass]="sidebarCollapsed ? 'w-[72px]' : 'w-[280px]'"
  >
    <div class="flex flex-col h-full">
      <div class="flex items-center flex-shrink-0 h-[60px]" [ngClass]="sidebarCollapsed ? 'px-3 justify-center' : 'px-4'">
        <img *ngIf="!sidebarCollapsed" [src]="brandService.logoPath" class="h-8 object-contain flex-1" />
        <img *ngIf="sidebarCollapsed" [src]="brandService.logoIconPath" class="w-8 h-8 object-contain" />
        <button
          *ngIf="!sidebarCollapsed"
          (click)="toggleSidebar()"
          class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200"
          pTooltip="Collapse"
          tooltipPosition="right"
        >
          <i class="pi pi-angle-double-left text-sm"></i>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto">
        <ng-container *ngTemplateOutlet="menuTemplate; context: { isMobile: false, isCollapsed: sidebarCollapsed }"></ng-container>
      </div>

      <!-- Toggle Button (only when collapsed) -->
      <div *ngIf="sidebarCollapsed" class="px-2 py-3 flex-shrink-0 border-t border-gray-100">
        <button
          (click)="toggleSidebar()"
          class="w-full flex items-center justify-center p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200"
          pTooltip="Expand"
          tooltipPosition="right"
        >
          <i class="pi pi-angle-double-right text-sm"></i>
        </button>
      </div>

      <!-- Version and Developer Info -->
      <div *ngIf="!sidebarCollapsed" class="px-4 py-2 flex-shrink-0 border-t border-gray-100 text-center">
        <p class="text-[10px] text-surface-500">
          v{{ appVersion }} • ©
          <a [href]="brandService.mainUrl" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">
            {{ brandService.brandName }}
          </a>
        </p>
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div
      class="h-[60px] flex justify-between items-center pl-6 pr-2 md:px-8 bg-surface-0 border-b border-surface relative lg:static flex-shrink-0"
    >
      <a
        pRipple
        class="cursor-pointer inline-flex items-center justify-center lg:hidden text-700 mr-3"
        (click)="openDrawer()"
      >
        <i class="pi pi-bars text-2xl text-gray-700"></i>
      </a>

      <div class="flex items-center ml-auto gap-1">
        <!-- Notifications bell -->
        <button
          type="button"
          class="relative flex items-center justify-center w-11 h-11 rounded-full hover:bg-surface-100 text-gray-700 transition-colors cursor-pointer"
          pTooltip="Notifications"
          tooltipPosition="bottom"
          (click)="loadNotifications(); notificationsPanel.toggle($event)"
        >
          <i class="pi pi-bell text-xl"></i>
          <span
            *ngIf="unreadCount > 0"
            class="absolute top-0 right-0 min-w-[17px] h-[17px] px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-semibold leading-none ring-2 ring-surface-0"
          >
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </button>

        <p-overlayPanel #notificationsPanel styleClass="w-80 md:w-96">
          <div class="flex items-center justify-between px-4 py-3 border-b border-surface">
            <span class="font-semibold text-primary-900">Notifications</span>
            <button
              *ngIf="unreadCount > 0"
              type="button"
              class="text-sm text-primary hover:underline cursor-pointer"
              (click)="markAllRead()"
            >
              Mark all read
            </button>
          </div>

          <div class="max-h-96 overflow-y-auto">
            <app-notifications-list
              [notifications]="notifications"
              (itemClick)="onNotificationClick($event); notificationsPanel.hide()"
            />
          </div>

          <a
            routerLink="/notifications"
            class="block text-center px-4 py-3 border-t border-surface text-sm text-primary hover:underline cursor-pointer"
            (click)="notificationsPanel.hide()"
          >
            See all notifications
          </a>
        </p-overlayPanel>

        <a
          class="flex p-3 lg:px-4 lg:py-2 items-center hover:bg-surface-100 font-medium rounded-border cursor-pointer duration-150 transition-colors"
          (click)="userMenu.toggle($event)"
        >
          <p-avatar [label]="userNameInitial" styleClass="mr-1 " shape="circle" />
          <div class="block ml-2">
            <div class="text-primary-900">{{ user.firstName }}</div>
          </div>
          <i class="pi pi-angle-down ml-1"></i>
        </a>
      </div>
    </div>
    <div class="flex-1 min-w-0 overflow-y-auto" id="main-content" [class]="paddingClass">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<p-menu #userMenu [model]="items" [popup]="true" class="flex justify-center" styleClass="md:w-60 user-menu py-2" />

<!-- Dynamic Menu Template -->
<ng-template #menuTemplate let-isMobile="isMobile" let-isCollapsed="isCollapsed">
  <div class="flex-grow">
    <ul class="list-none m-0" [ngClass]="{ 'p-3 mt-5': !isMobile && !isCollapsed, 'p-2 mt-3': isCollapsed }">
      <li>
        <ul class="list-none p-0 m-0 overflow-hidden">
          <ng-container *ngFor="let item of menuItems">
            <!-- Menu item without children -->
            <li *ngIf="!hasVisibleChildren(item)">
              <!-- Internal router link -->
              <a
                *ngIf="item.routerLink"
                pRipple
                class="rounded-xl flex items-center cursor-pointer p-3 text-primary-900 border-2 border-transparent duration-150 transition-colors hover:bg-gray-100"
                [ngClass]="{ 'justify-center': isCollapsed }"
                [routerLink]="item.routerLink"
                routerLinkActive="bg-gray-100"
                [pTooltip]="item.label"
                tooltipPosition="right"
                [tooltipDisabled]="!isCollapsed"
              >
                <i [class]="item.icon" [ngClass]="{ 'mr-2': !isCollapsed }"></i>
                <span class="font-medium" *ngIf="!isCollapsed">{{ item.label }}</span>
              </a>
              <!-- External URL -->
              <a
                *ngIf="item.externalUrl"
                pRipple
                [href]="item.externalUrl"
                target="_blank"
                class="rounded-xl flex items-center cursor-pointer p-3 text-primary-900 border-2 border-transparent duration-150 transition-colors hover:bg-gray-100"
                [ngClass]="{ 'justify-center': isCollapsed }"
                [pTooltip]="item.label"
                tooltipPosition="right"
                [tooltipDisabled]="!isCollapsed"
              >
                <i [class]="item.icon" [ngClass]="{ 'mr-2': !isCollapsed }"></i>
                <span class="font-medium" *ngIf="!isCollapsed">{{ item.label }}</span>
              </a>
            </li>

            <!-- Menu item with children (collapsible) - expanded sidebar -->
            <li *ngIf="hasVisibleChildren(item) && !isCollapsed">
              <a
                pRipple
                class="flex items-center cursor-pointer p-3 rounded text-primary-900 hover:bg-gray-100 transition duration-150"
                (click)="toggleDropdown(item.id)"
              >
                <i [class]="item.icon + ' mr-2'"></i>
                <span class="font-medium">{{ item.label }}</span>
                <i
                  class="pi pi-angle-right ml-auto transition-transform duration-200"
                  [ngClass]="{ 'rotate-90': dropdowns[item.id] }"
                ></i>
              </a>
              <ul
                *ngIf="dropdowns[item.id]"
                class="list-none py-0 pl-3 pr-0 m-0 overflow-y-hidden"
              >
                <li *ngFor="let child of item.children">
                  <a
                    pRipple
                    [routerLink]="child.routerLink"
                    routerLinkActive="bg-gray-100"
                    class="rounded-xl flex items-center cursor-pointer px-3 py-2 text-primary-900 border-2 border-transparent duration-150 transition-colors"
                  >
                    <span class="font-medium">{{ child.label }}</span>
                  </a>
                </li>
              </ul>
            </li>

            <!-- Menu item with children - collapsed sidebar (just icon) -->
            <li *ngIf="hasVisibleChildren(item) && isCollapsed">
              <a
                pRipple
                [routerLink]="item.children![0].routerLink"
                routerLinkActive="bg-gray-100"
                class="rounded-xl flex items-center justify-center cursor-pointer p-3 text-primary-900 border-2 border-transparent duration-150 transition-colors hover:bg-gray-100"
                [pTooltip]="item.label"
                tooltipPosition="right"
              >
                <i [class]="item.icon"></i>
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ul>
  </div>
</ng-template>
